module.exports = __webpack_public_path__ + "static/media/speaker.bde68982.png";